import HeaderClientes from "components/_refactor/headers/clients";
import { Container, Grid } from "@material-ui/core";
import FilterCard from "components/_refactor/filter-card";
import InputText from "components/_refactor/text/input";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import { useState, useEffect } from "react";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import useStructureQueries from "hooks/useStructureQueries";
import TableSuppliers from "./components/table-suppliers";
import DialogSupplier from "./components/dialog-supplier";
import DialogConfirmarExclusao from "./components/dialog-confirmar-exclusao";
import MaskAndValid from "utils/maskAndValid";

const statusOptions = [
  { value: "ATIVO", label: "Ativo" },
  { value: "EM_AVALIACAO", label: "Em Avaliação" },
  { value: "PENDENTE", label: "Pendente" },
  { value: "INATIVO", label: "Inativo" },
];

export default function GestaoFornecedoresHomologados() {
  const snackbar = useSnackbar();

  const [searching, setSearching] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [supplierToEdit, setSupplierToEdit] = useState(null);
  const [supplierToDelete, setSupplierToDelete] = useState(null);
  const [fornecedores, setFornecedores] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [filter, setFilter] = useState({
    search: "",
    category: null,
    status: null,
  });

  const userDetail = JSON.parse(localStorage.getItem("userDetail") || "null");
  const isFranchise =
    !!userDetail?.UsuarioPerfis?.find(perfil => perfil.NomePerfil === "FRANQUEADO_VENDEDOR");

  const { getListSupplierCategories } = useStructureQueries();

  useEffect(() => {
    async function getCategories() {
      setCategoriesLoading(true);
      try {
        const result = await getListSupplierCategories();
        const res = result?.data ?? {};
        setCategories(res?.Items || res?.Categorias || []);
      } catch (error) {
        snackbar.showMessage(error?.toString() || "Erro ao buscar categorias", {
          severity: "error",
        });
      } finally {
        setCategoriesLoading(false);
      }
    }
    getCategories();
  }, [snackbar, getListSupplierCategories]);

  const handleSearch = async () => {
    setSearching(true);
    try {
      const params = new URLSearchParams();
      
      if (filter.search?.trim()) {
        params.append("nomeFantasia", filter.search.trim());
      }
      
      if (filter.category?.IdDocumentoAreaCategoria) {
        params.append("idCategoriaFornecedor", filter.category.IdDocumentoAreaCategoria.toString());
      }
      
      if (filter.status?.value) {
        params.append("statusHomologacao", filter.status.value);
      }

      const queryString = params.toString();
      const parameter = queryString ? `?${queryString}` : "";

      const response = await Api.get("list-suppliers", "franquias", parameter, true);
      
      const items = response?.Result?.Items || [];
      
      const mappedItems = items.map((item) => {
        const category = categories.find(
          (cat) => cat.IdFranquiaCategoriaFornecedor === item.IdCategoriaFornecedor
        );

        return {
          IdFornecedor: item.IdFranquiaFornecedor,
          Nome: item.NomeFantasia,
          NomeFantasia: item.NomeFantasia,
          Categoria: category?.Nome || "-",
          IdCategoriaFornecedor: item.IdCategoriaFornecedor,
          Contato: item.ContatoPrincipal || "-",
          ContatoPrincipal: item.ContatoPrincipal,
          Slug: item.ContatoPrincipal.replace(' ', '.').toLowerCase(),
          Telefone: item.Telefone ? MaskAndValid.maskPhone(item.Telefone) : "-",
          Email: item.Email || "-",
          Status: item.StatusHomologacao || "EM_AVALIACAO",
          StatusHomologacao: item.StatusHomologacao,
          RazaoSocial: item.RazaoSocial,
          Cnpj: item.Cnpj ? MaskAndValid.maskCPNJCPF(item.Cnpj) : "-",
          Site: item.Site,
          Observacao: item.Observacao,
          Ativo: item.Ativo,
          DataInclusao: item.DataInclusao,
          DataInclusaoFormat: item.DataInclusaoFormat,
        };
      });

      setFornecedores(mappedItems);
    } catch (error) {
      snackbar.showMessage(error?.toString() || "Erro ao buscar fornecedores", {
        severity: "error",
      });
      setFornecedores([]);
    } finally {
      setSearching(false);
    }
  };

  return (
    <>
      <HeaderClientes section={isFranchise ? "Fornecedores Homologados" : "Gestão Fornecedores Homologados"} subsection="Operações" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={categoriesLoading || searching}
          searching={searching}
        >
          <Grid item xs={12} lg={6}>
            <InputText
              label="Nome Fantasia"
              value={filter.search}
              onChange={(e) => setFilter({ ...filter, search: e.target.value })}
              disabled={searching}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} lg={4}>
            <AutoCompleteField
              label="Categoria"
              onChange={(value) => setFilter({ ...filter, category: value })}
              value={filter.category}
              options={categories}
              optionLabelKey="Nome"
              optionIdKey="IdDocumentoAreaCategoria"
              loading={categoriesLoading}
              disabled={categoriesLoading || searching}
            />
          </Grid>
          <Grid item xs={12} lg={2}>
            <AutoCompleteField
              label="Status"
              onChange={(value) => setFilter({ ...filter, status: value })}
              value={filter.status}
              options={statusOptions}
              optionLabelKey="label"
              optionIdKey="value"
            />
          </Grid>
        </FilterCard>
        <TableSuppliers
          data={fornecedores}
          loading={searching}
          readOnly={isFranchise}
          onAddSupplier={() => {
            setSupplierToEdit(null);
            setOpenDialog(true);
          }}
          onEdit={(row) => {
            setSupplierToEdit(row);
            setOpenDialog(true);
          }}
          onViewDetails={(row) => {
            setSupplierToEdit(row);
            setOpenDialog(true);
          }}
          onExcluir={(row) => setSupplierToDelete(row)}
          onInativarReativar={async (row) => {
            try {              
              const body = {
                idFranquiaFornecedor: row.IdFornecedor,
              };

              await Api.put("inactivate-supplier", "franquias", body, true);
              
              snackbar.showMessage(
                "Fornecedor inativado com sucesso.",
                { severity: "success" }
              );
              handleSearch();
            } catch (error) {
              snackbar.showMessage(
                error?.toString() || "Erro ao alterar status do fornecedor.",
                { severity: "error" }
              );
            }
          }}
          onResearch={handleSearch}
        />
      </Container>
      <DialogSupplier
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setSupplierToEdit(null);
        }}
        onSaved={() => {
          setOpenDialog(false);
          setSupplierToEdit(null);
          handleSearch();
        }}
        supplier={supplierToEdit}
        categories={categories}
        readOnly={isFranchise}
      />
      {!isFranchise && (
        <DialogConfirmarExclusao
          open={!!supplierToDelete}
          onClose={() => setSupplierToDelete(null)}
          supplier={supplierToDelete}
          onExcluido={() => {
            setSupplierToDelete(null);
            handleSearch();
          }}
          snackbar={snackbar}
        />
      )}
    </>
  );
}